import * as React from "react";
import PropTypes from "prop-types";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { HTMLContent } from "../components/Content";
import showdown from 'showdown'
// for converting markdown String to valid Html
const markdownConverter = new showdown.Converter()

const NewsCard = ({ title, description, date, image, newsRelatedFile }) => {
    const displayableImage = getImage(image) || image;
    // convert markdown string to html
    const content = markdownConverter.makeHtml(description);

    return (
        <div key={title} className="customContainer mt-4">
            <section className="section">
                <div className="columns">
                    <div className="column is-6">
                        <GatsbyImage
                            image={displayableImage}
                            // rounded image???
                            // objectFit={"cover"}
                            objectPosition="center center"
                            style={{
                                height: "240px",
                                width: "360px",
                                maxWidth: "100%"
                            }}
                            alt="" // {imageAlt}
                        // formats={["auto", "webp", "avif"]}
                        />
                    </div>
                    <div className="column is-6 leftAligned">
                        <h2 class="title isShadows">{title}</h2>
                        <p></p>
                        <h4 class="subtitle">{date}</h4>
                        <HTMLContent content={content} />
                        {newsRelatedFile !== null &&
                            <a href={newsRelatedFile.publicURL} download>
                                More Infos here!
                            </a>
                        }
                    </div>
                </div>
            </section >
        </div >
    )
};

NewsCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    date: PropTypes.string,
    image: PropTypes.object,
    imageAlt: PropTypes.string,
};

export default NewsCard;
